var SCM = SCM || {};
var App = App || {};

(function (iou, $, ls, undefined) {
    var instOpenUrlKey = 'instOpenUrlKey_';

    iou.replaceOpenUrlPlaceHolders = function (openUrlPlaceHolderElements, replaceLinkHtml) {
        if (replaceLinkHtml !== null && replaceLinkHtml !== '') {
            openUrlPlaceHolderElements.each(function () {
                var targetId = $(this).attr('data-targetId');
                var finalLinkHtml = replaceLinkHtml.replace('{openUrlTargetId}', targetId);
                $(this).html(finalLinkHtml);
                $(this).parent().show();
            });
        }
    };

    iou.getAndReplaceOpenUrlPlaceHolders = function (openUrlPlaceHolderElements) {
        var ajaxUrl = '/ThirdParty/InstitutionOpenUrlTemplate';
        $.ajax({
            type: 'POST',
            url: ajaxUrl,
            dataType: 'json',
            success: function (resultObject) {
                if (resultObject !== null && resultObject !== 'undefined') {
                    // json result object properties
                    // TargetUrl , DisplayOpenUrlLink , HasOpenUrlImage, LinkImageSource ,LinkImageText 
                    var replacelink = '';
                    if (resultObject.DisplayOpenUrlLink == true) {
                        if (resultObject.LinkImageSource !== null && resultObject.LinkImageSource !== '') {
                            replacelink = ' <a target="_blank" href="' + resultObject.TargetUrl + '"><img src="' + resultObject.LinkImageSource + '" alt="Find at ' + resultObject.InstitutionName + '" /></a > ';
                        } else {
                            replacelink = ' <a target="_blank" href="' + resultObject.TargetUrl + '"> ' + resultObject.LinkImageText + ' </a> ';
                        }
                    }
                    // now loop through each placeholders to 
                    iou.replaceOpenUrlPlaceHolders(openUrlPlaceHolderElements, replacelink);
                    // now that we determined replacement link, store it in session storage
                    if (ls !== null && window.sessionStorage !== null && typeof window.App.LoginUserInfo !== 'undefined' && typeof window.App.LoginUserInfo.currentSessionId !== 'undefined') {
                        ls.setItem(instOpenUrlKey + window.App.LoginUserInfo.currentSessionId, replacelink, window.sessionStorage);
                    }
                }
            },
            error: function (errdata) {

            }
        });
    };

    iou.checkAndReplaceOpenUrlPlaceHolders = function () {

        // 1) it depends on App.LoginUserInfo.IsInstLoggedIn value to determine if institution is logged in
        // that object should be initialized and values set at master page level.
        // 2) If institution is logged in and also if there are any instOpenUrlPlaceHolders
        // then do ajax call to get openUrlTemplate for logged in institution

        if (typeof window.App.LoginUserInfo !== 'undefined' && window.App.LoginUserInfo.isInstLoggedIn > 0) {
            // check if article has any openurl templates
            var openUrlPlaceHolders = $('span[class="inst-open-url-holders"]');
            if (openUrlPlaceHolders !== null && openUrlPlaceHolders !== undefined && openUrlPlaceHolders.length > 0) {
                // now check html5 session storage
                // if value exists get replacementLinkHtml, if not go get
                if (ls !== null && window.sessionStorage !== null && typeof window.App.LoginUserInfo.currentSessionId !== 'undefined') {
                    var storedLink = ls.getItem(instOpenUrlKey + window.App.LoginUserInfo.currentSessionId, window.sessionStorage);
                    if (storedLink !== null) {
                        iou.replaceOpenUrlPlaceHolders(openUrlPlaceHolders, storedLink);
                    } else {
                        iou.getAndReplaceOpenUrlPlaceHolders(openUrlPlaceHolders);
                    }
                }
                else {
                    iou.getAndReplaceOpenUrlPlaceHolders(openUrlPlaceHolders);
                }
            }
        }
    };

    iou.init = function () {
        // articleFullText widget will leave placeholders for each openUrl token found in reference sectionxml
        // if an institution logged in, this script will get a urltemplate based institutionOpenUrl settings and 
        // replace these placeholders with template populated with appropriate values
        iou.checkAndReplaceOpenUrlPlaceHolders();
        $(window).on('SCM-SharedWidgets-AsyncWidgetLoader_LOADED', iou.checkAndReplaceOpenUrlPlaceHolders);
    };
    iou.init();
})(SCM.InstitutionOpenUrl = SCM.InstitutionOpenUrl || {}, jQuery, SCM.Utilities.LocalStorage);